import { useState } from 'react'

export const useExpandableMenu = (options: {
  isUserAuthenticated: boolean
}) => {
  const [isExpanded, setIsExpanded] = useState(false)

  const expandMenu = () => {
    options.isUserAuthenticated && setIsExpanded(true)
  }

  const collapseMenu = () => {
    options.isUserAuthenticated && setIsExpanded(false)
  }

  return {
    isExpanded,
    setIsExpanded,
    expandMenu,
    collapseMenu
  }
}
